import { createVanIconComponent } from "./van"

const Manager = createVanIconComponent("manager")
export default Manager
